import React, { useState } from 'react';
import classnames from 'classnames';

import './style.scss';

import WysiwygField from '../../WysiwygField';

const Faq = ({ question, answer, className, type = 'underline' }) => {

  const [OpenAnswer, setOpenAnswer] = useState(false);

  const toggleAnswer = () => {
    setOpenAnswer(!OpenAnswer);
  };

  return (
    <div
      className={classnames(className, 'Faq', `Faq__${type}`, { Faq__open: OpenAnswer })}
    >
      <button type="button" className="Faq__question" onClick={toggleAnswer}>
        <div className="icon icon-plus icon-variant-0" />
        <h5 className="Faq__title">{ question }</h5>
      </button>
      <div className="Faq__answer">
        {answer && (
          <WysiwygField
            property="schema:text"
            className="subheading2"
            html={answer}
          />
        )}
      </div>
    </div>
  );
};

export default Faq;
